export default __webpack_public_path__ + "static/media/Edit.393ee00c.svg";